import React from 'react'
import { SVGIconProps } from '../types'
const SvgSportsBasketball = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M17.09 11h4.86a9.95 9.95 0 0 0-1.54-4.4 5.99 5.99 0 0 0-3.32 4.4M6.91 11a5.99 5.99 0 0 0-3.32-4.4A9.95 9.95 0 0 0 2.05 11zm8.16 0a8 8 0 0 1 4.06-6A9.97 9.97 0 0 0 13 2.05V11zm-6.14 0H11V2.05A9.94 9.94 0 0 0 4.87 5a8 8 0 0 1 4.06 6m6.14 2H13v8.95A9.94 9.94 0 0 0 19.13 19a8 8 0 0 1-4.06-6M3.59 17.4A6.03 6.03 0 0 0 6.91 13H2.05c.16 1.61.71 3.11 1.54 4.4m13.5-4.4a5.99 5.99 0 0 0 3.32 4.4 9.95 9.95 0 0 0 1.54-4.4zm-8.16 0a8 8 0 0 1-4.06 6A9.97 9.97 0 0 0 11 21.95V13z" />
  </svg>
)
export default SvgSportsBasketball
